import { Typography } from "@mui/material";

const StepTitle = ({ title }) => {
  return (
    <Typography
      variant="title"
      sx={{
        display: "flex",
        justifyContent: "center",
        textAlign: "center",
        mb: 2,
      }}
    >
      {title}
    </Typography>
  );
};

export default StepTitle;
